// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1txRM","footer":"ChangeClinic_footer__V6UZA"};